// form-theme.ts (plain utility, no hooks)
export const applyTheme = (theme?: Record<string, string>) => {
	if (!theme) return
	const root = document.documentElement
	for (const [key, value] of Object.entries(theme)) {
		root.style.setProperty(`--df-${key}`, value)
	}
}

export const applyThemeMode = (mode: string) => {
	const root = document.querySelector<HTMLElement>(".df-form-container")
	if (!root) return
	root.classList.remove("light", "dark") // clear previous
	root.classList.add(mode)
}
